import {Component, Input, Output, EventEmitter, computed, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { TooltipDirective } from '../../../../../shared/directives';
import {AuthenticationService} from '../../../../../core/services/authentication/authentication.service';
import {ROLE_VTEX_ORDERS_WRITE} from '../../../../../core/models/user/user-info.model';

export type Severity = 'error' | 'warning' | 'info';

export interface Inconsistency {
  severity: Severity;
  message: string;
  code?: string;
  invoice?: string;
}

@Component({
  selector: 'app-order-inconsistencies',
  standalone: true,
  imports: [CommonModule, ButtonComponent, TooltipDirective],
  templateUrl: './order-inconsistencies.component.html',
})
export class OrderInconsistenciesComponent {
  @Input({ required: true }) inconsistencies: Inconsistency[] = [];
  @Input({ required: true }) isReprocessingOrder: boolean = false;
  /** When true, reprocess/request workflow is disabled (workflow already exists) */
  @Input() hasActiveWorkflow = false;
  @Output() reprocessInvoice = new EventEmitter<void>();

  private readonly authService: AuthenticationService = inject(AuthenticationService);

  get isAllowedToReprocess(): boolean {
    return this.authService.hasRole(ROLE_VTEX_ORDERS_WRITE);
  }

  severitySummary = computed(() => {
    const hasError = this.inconsistencies.some(i => i.severity === 'error');
    const hasWarning = this.inconsistencies.some(i => i.severity === 'warning');

    if (hasError) return { label: 'Há inconsistências críticas', severity: 'error' as const };
    if (hasWarning) return { label: 'Há pontos de atenção', severity: 'warning' as const };
    return { label: 'Nenhuma inconsistência encontrada', severity: 'info' as const };
  });

  onReprocessClick(): void {
    this.reprocessInvoice.emit();
  }
}
